import { ApolloError, useQuery } from '@apollo/client';

import { handleGql403 } from '../../../utils';
import { GetReportTemplateQuery, GetReportTemplateQueryVariables } from '../types';
import { GET_REPORT_TEMPLATE } from './getReportTemplate';

export type ReportTemplateResponse = {
  data?: GetReportTemplateQuery['template'];
  loading: boolean;
  error?: ApolloError;
};

const useReportTemplate = (id: string): ReportTemplateResponse => {
  const { data, loading, error } = useQuery<GetReportTemplateQuery, GetReportTemplateQueryVariables>(
    GET_REPORT_TEMPLATE,
    {
      variables: {
        id,
      },
      onError: handleGql403,
    }
  );

  return {
    ...(data?.template && { data: data.template }),
    loading: loading,
    error,
  };
};

export default useReportTemplate;
